import React, {useState} from 'react';
import {RouteComponentProps} from 'react-router-dom';
import {Form} from "react-bootstrap";
import {BoardEntity, HttpMethod} from "../../model";
import {httpClient} from "../../service";
import TermsModal from "../TermsModal";

const BoardWrite =
    (props: RouteComponentProps<{ id: string }>) => {
        const match = props.match;
        console.log(match.params.id);
        const forumCode = match.params.id ?? 'notice';
        const [validated, setValidated] = useState(false);
        const [model, setModel] = useState<BoardEntity>({forumCode: forumCode});
        const [submitting, setSubmitting] = useState(false);
        const placeHolderTxt = match.params.id.indexOf('qna')>=0 ? '연락처를 남겨주시면 원활한 상담 가능\n문의 후 1~3일 이내 \'문의하기\'에서 답변 확인 가능': '문의내용을 적어주세요';
        const submitForm = async (e: any) => {
            const isValid = e.currentTarget.checkValidity();
            if (!isValid) {
                e.preventDefault();
                e.stopPropagation();
                setValidated(true);
                return false;
            }
            e.preventDefault();
            const form = e.target;
            setSubmitting(true);
            console.log(`form state=${JSON.stringify(model)}`);
            const url = 'boards';
            const option = {
                url: url,
                method: HttpMethod.POST,
                body: model
            };
            const act = await httpClient(option);
            setSubmitting(false);

            if (act.result) {
                alert('문의가 정상적으로 접수되었습니다.');
                const data: BoardEntity = {writer: '', tel: '',content:'',subject:''};
                setModel(data);
                form.reset();
                props.history.push(`/boards/${forumCode}`);

            } else {
                alert(`오류:${act.errorMsg}`);
            }
        };
        const handleInputChange = (e: any) => {
            console.log(`name=${e.target.name}, value=${e.target.value}`);
            const data = {...model, [e.target.name]: e.target.value};
            setModel(data);
        }
        return (
            <div className="bloc l-bloc" id="bloc-0">
                <div className="container bloc-sm">
                    <div className="row">
                        <div className="col-lg-6 offset-lg-3 offset-md-2 col-md-8">
                            <Form data-form-type="blocs-form" noValidate validated={validated}
                                  onSubmit={submitForm}>
                                <h6 className="mg-md subtitle">항상 최선의 서비스를 드리기 위해 노력합니다.<br/></h6>
                              {/*  <Form.Group>
                                    <Form.Label
                                        className="form-label">이름&nbsp;*</Form.Label>
                                    <Form.Control name="writer" required onChange={handleInputChange}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        이 항목은 필수항목입니다.
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group>
                                    <Form.Label
                                        className="form-label">연락처 또는 이메일&nbsp;*</Form.Label>
                                    <Form.Control name="tel" required onChange={handleInputChange}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        이 항목은 필수항목입니다.
                                    </Form.Control.Feedback>
                                </Form.Group>*/}
                                <Form.Group>
                                    <Form.Label
                                        className="form-label">제목&nbsp;*</Form.Label>
                                    <Form.Control name="subject" required onChange={handleInputChange}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        이 항목은 필수항목입니다.
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group>
                                    <Form.Label>문의 내용 *</Form.Label>
                                    <Form.Control as="textarea" onChange={handleInputChange} rows={4} cols={50} required
                                                  name="content" placeholder={placeHolderTxt}></Form.Control>
                                </Form.Group>
                                <button type="submit"
                                        className="bloc-button btn btn-d btn-lg btn-block download-bt"
                                        disabled={submitting}
                                >{submitting ? "전송중.." : "문의하기"}
                                </button>
                                <TermsModal />
                            </Form>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

export default BoardWrite;
